export { TestBackend as default } from 'react-dnd-test-backend';
